import { Classroom } from "../types/ClassroomModel"; // Import Classroom type from your types directory
import api from "./api"; // Import your configured Axios instance

// Fetch all classrooms
export const getClassrooms = async () => {
  try {
    const response = await api.get("/classrooms");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch classrooms", error);
    throw error;
  }
};

// Fetch a single classroom by ID
export const getClassroom = async (id: string) => {
  try {
    const response = await api.get(`/classrooms/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch classroom", error);
    throw error;
  }
};

// Create a new classroom
export const createClassroom = async (classroomData: Classroom) => {
  try {
    const response = await api.post("/classrooms", classroomData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error saving classroom:", error);
    throw error;
  }
};

// Update an existing classroom by ID
export const updateClassroom = async (
  classroomId: string,
  updatedData: Classroom
) => {
  try {
    const response = await api.put(`/classrooms/${classroomId}`, updatedData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating classroom:", error);
    throw error;
  }
};

// Delete a classroom by ID
export const deleteClassroom = async (classroomId: string) => {
  try {
    const response = await api.delete(`/classrooms/${classroomId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting classroom:", error);
    throw error;
  }
};

// Phase 1: Student progress
export const getStudentProgress = async (classroomId: string) => {
  const response = await api.get(`/classrooms/${classroomId}/student-progress`);
  return response.data;
};

// Phase 4: Analytics
export const getClassAnalytics = async (classroomId: string) => {
  const response = await api.get(`/classrooms/${classroomId}/analytics`);
  return response.data;
};

// Phase 2: Quiz results
export const getQuizResults = async (classroomId: string, params?: { studentId?: string; moduleId?: string }) => {
  const response = await api.get(`/classrooms/${classroomId}/quiz-results`, { params });
  return response.data;
};

// Phase 3: Student detail
export const getStudentDetail = async (classroomId: string, studentId: string) => {
  const response = await api.get(`/classrooms/${classroomId}/students/${studentId}/detail`);
  return response.data;
};

export const emailClassroomStudents = async (
  classroomId: string,
  payload: { subject: string; message: string; studentIds: string[] }
) => {
  const response = await api.post(
    `/classrooms/${classroomId}/email-students`,
    payload
  );
  return response.data;
};

export const addStudentsToClassroom = async (
  classroomId: string,
  students: { id: string; name: string }[],
  emailOptions?: {
    sendToAdded: boolean;
    sendToRemoved: boolean;
  }
) => {
  try {
    const response = await api.post(`/classrooms/${classroomId}/add-students`, {
      students,
      emailOptions, // Send both id and name
    });
    return response.data;
  } catch (error) {
    console.error("Error adding students to classroom:", error);
    throw error;
  }
};
